<template>
  <main v-if="$page" class="privacy-policy">
    <PageHeader :content="$page.header" />
    <RawHtml :html="$page.privacy_policy" :preserve-breaks="true" />
  </main>
</template>
<script>
import RawHtml from '@/components/global/RawHtml.vue'
import PageHeader from '@/components/sections/PageHeader.vue'
import PageMetaMixin from '@/mixins/PageMetaMixin.js'

export default {
  name: 'PrivacyPolicyView',
  beetPage: 'privacy_policy',
  mixins: [PageMetaMixin],
  components: { PageHeader, RawHtml },
}
</script>
